import { render, staticRenderFns } from "./LifeInfo.vue?vue&type=template&id=534f1b61&scoped=true"
import script from "./LifeInfo.vue?vue&type=script&lang=js"
export * from "./LifeInfo.vue?vue&type=script&lang=js"
import style0 from "./LifeInfo.vue?vue&type=style&index=0&id=534f1b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f1b61",
  null
  
)

export default component.exports